import { createSelector } from 'reselect';
 
const selectTopics = (state: any) => state.topics;
 
export const selectTopicsCurrentItem = createSelector([selectTopics], (topics) => topics.current);
 
export const selectTopicsListItems = createSelector([selectTopics], (topics) => topics.list);
 
 
export const selectTopicsItemById = (itemId: any) =>
    createSelector(selectTopicsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectTopicsQueryItems = createSelector([selectTopics], (topics) => topics.query);

export const selectTopicsCreatedItem = createSelector([selectTopics], (topics) => topics.create);
 
export const selectTopicsUpdatedItem = createSelector([selectTopics], (topics) => topics.update);
 
export const selectTopicsReadItem = createSelector([selectTopics], (topics) => topics.read);
 
export const selectTopicsDeletedItem = createSelector([selectTopics], (topics) => topics.delete);
 
export const selectTopicsSearchedItems = createSelector([selectTopics], (topics) => topics.search);
 
export const selectTopicsItemsCount = createSelector([selectTopics], (topics) => topics.count);
 
export const selectTopicsItemsFilter = createSelector([selectTopics], (topics) => topics.filter);